import { Expose, Type } from "class-transformer";
import { IsNumber, IsString, IsArray, ValidateNested, IsBoolean, IsOptional } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class GDS {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  translatedName!: string;
  @IsString()
  @Expose()
  shortName!: string;
  @IsBoolean()
  @Expose()
  isActive!: boolean;
}

export class GDSService {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  name!: string;
  @IsString()
  @IsOptional()
  @Expose()
  code!: string | null;
  @IsString()
  @Expose()
  vat!: string;
}

export class GDSServiceResponse extends GenericTableResponse<GDSService> {
  @Expose()
  @IsArray()
  @Type(() => GDSService)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<GDSService>;
}

export class GDSSettings {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  name!: string;
  @IsBoolean()
  @Expose()
  isSet!: boolean;
  @IsBoolean()
  @Expose()
  isCostDocumentRequired!: boolean;
}

export class GDSFormOfPayment {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  name!: string;
  @IsBoolean()
  @Expose()
  isPicked!: boolean;
}
